import React from "react";
import "./style.scss";
import { Modal } from "@mui/material";
import AllDoctorsContent from "./AllDoctorContent";

const SelectDoctorDesktopView = (props) => {
  const { show, onHide } = props;

  return (
    <>
      {show ? (
        <Modal
          open={show}
          className="modal-container"
        >
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="all-doctor-content-modal-wrapper">
              <AllDoctorsContent show={show} onHide={onHide} />
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
};
export default SelectDoctorDesktopView;
